import script from "./SkeletonLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkeletonLoader.vue?vue&type=script&setup=true&lang=ts"

import "./SkeletonLoader.vue?vue&type=style&index=0&id=64878920&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64878920"]])

export default __exports__